export default __webpack_public_path__ + "locales/uk-UA/VersionHistory.json?hash=5af254460f2f1644e10c966fdca3c13c";